export const taskpartStudentTiers = [
  {
    id: "free",
    name: "Free Student Account",
    priceLabel: "Free",
    accent: "#0A2F6B",
    shortLabel: "Free access",
    description:
      "Register, build your profile, explore how Taskpart works, and access selected readiness resources without payment.",
    features: [
      "Create a student profile",
      "Access selected free courses",
      "View selected opportunities",
      "Receive career tips and webinar updates",
      "Apply for a limited number of work slots",
    ],
  },
  {
    id: "verified",
    name: "Verified Student Account",
    priceLabel: "TZS 10,000 / year",
    accent: "#1E8E43",
    shortLabel: "Trust and access",
    description:
      "Unlock verified access for serious practical experience, employer visibility, work logs, certificates, and recommendation eligibility.",
    features: [
      "Identity and student-status verification",
      "Verified digital badge",
      "Access to partner work slots",
      "Work log activation and completion records",
      "Certificate and recommendation eligibility",
      "Priority matching with partner companies",
    ],
  },
  {
    id: "premium",
    name: "Premium Career Account",
    priceLabel: "TZS 50,000 one-time",
    accent: "#C6861A",
    shortLabel: "Career acceleration",
    description:
      "Add deeper professional support for students who want intensive preparation beyond placement readiness.",
    features: [
      "Paid professional courses",
      "CV review and profile optimization",
      "Interview preparation",
      "Career coaching sessions",
      "Advanced certificates",
      "Priority placement and exclusive employer programs",
    ],
  },
];

export const taskpartOrientationModules = [
  "Work ethics",
  "Communication",
  "Timekeeping",
  "Reporting",
  "Professional behavior",
];

export const taskpartFreeCourseTopics = [
  "Workplace behavior",
  "Communication skills",
  "Time management",
  "Basic CV writing",
  "Introduction to professional ethics",
  "Customer service basics",
  "Introduction to digital skills",
];

export const taskpartPaidCourseTopics = [
  "Advanced Excel for workplace",
  "Sales and customer care",
  "Digital marketing",
  "Accounting software basics",
  "HR administration basics",
  "Project management basics",
  "Entrepreneurship and business skills",
  "Interview mastery",
  "Professional report writing",
  "AI tools for productivity",
];

export const taskpartPolicyDocuments = [
  "Student Terms and Conditions",
  "Partner Terms and Conditions",
  "Verification Fee Policy",
  "Refund Policy",
  "Student Code of Conduct",
  "Partner Code of Conduct",
  "Work Slot Posting Guidelines",
  "Partner Appreciation Contribution (PAC) Policy",
  "Certificate Issuance Policy",
  "Recommendation Letter Policy",
  "Data Privacy Policy",
  "Dispute Resolution Policy",
];

export const taskpartOpportunityPreviews = [
  {
    id: "preview-1",
    title: "Customer Support Trainee",
    company: "Tigo Tanzania",
    location: "Dar es Salaam",
    duration: "8 weeks",
    arrangement: "On-site",
    skills: ["Communication", "Customer service", "Reporting"],
    pacNote: "PAC may be offered after confirmed completion.",
  },
  {
    id: "preview-2",
    title: "Accounts Assistant Intern",
    company: "CRDB Bank",
    location: "Dar es Salaam",
    duration: "12 weeks",
    arrangement: "Hybrid",
    skills: ["Excel", "Bookkeeping", "Professional ethics"],
    pacNote: "Structured completion record and certificate eligible.",
  },
  {
    id: "preview-3",
    title: "Digital Marketing Assistant",
    company: "AzamPay Tanzania",
    location: "Remote",
    duration: "10 weeks",
    arrangement: "Remote",
    skills: ["Communication", "Social media", "AI tools"],
    pacNote: "Priority for verified students with completed orientation.",
  },
];
